// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import LocationInput from 'components/LocationInput';
import { setGMapsError } from '../redux/main/actions/gMapsError';

type OwnProps = {
  placeholder?: string,
  locationText: ?string,
  onChange: (?SearchLocation, ?boolean) => void,
  onBlur?: Function,
  showClearButton: boolean,
  className?: string,
  disabled?: boolean,
  includeFull?: boolean,
  validateOnBlur?: boolean
};

type Props = {
  ...$Exact<OwnProps>,
  gMapsErrored: boolean,
  setGMapsError: Function
};

type State = {
  locationInputValue: string,
  prevPropsLocationText: ?string
};

class LocationInputContainer extends React.Component<Props, State> {
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    showClearButton: false
  };

  state = {
    locationInputValue: this.props.locationText || '',
    // eslint-disable-next-line react/no-unused-state
    prevPropsLocationText: this.props.locationText
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    // if the search location changes in the Redux store, update the
    // search input with the new value
    if (props.locationText !== state.prevPropsLocationText) {
      return {
        locationInputValue: props.locationText || '',
        prevPropsLocationText: props.locationText
      };
    }
    return null;
  }

  clearLocation = (shouldEnqueueSearch?: boolean) => {
    this.setState({ locationInputValue: '' });
    this.props.onChange(undefined, shouldEnqueueSearch);
  };

  onLocationInputValueChange = (
    e: InputEvent,
    { newValue }: { newValue: string }
  ) => {
    if (newValue === '') {
      this.clearLocation(false);
    }
    this.setState({ locationInputValue: newValue });
  };

  render() {
    const {
      locationText,
      onChange,
      className,
      onBlur,
      ...inputProps
    } = this.props;
    return (
      <LocationInput
        {...inputProps}
        locationInputValue={this.state.locationInputValue}
        showClearButton={
          this.props.showClearButton && !!this.state.locationInputValue
        }
        clearLocation={() => this.clearLocation(false)}
        onLocationChange={onChange}
        onLocationInputValueChange={this.onLocationInputValueChange}
        className={className}
        hasRemoteOptions
        showLocationIcon
      />
    );
  }
}

const mapStateToProps = ({ gMapsError: { errored } }) => ({
  gMapsErrored: errored
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { setGMapsError }
)(LocationInputContainer);
